import React from 'react';

const Privadoqr = (props) => {
  return <>
  { 
   <div className="barcodeInner ">
          <bottom  onClick={props.func} className="qrclosebtn" type="button"><i class="fa-regular fa-xmark"></i></bottom>
          <h4>Steps to connect with Privado ID</h4>
          <div className="steps mt-3">
            <p><b>Step 1:</b> Download the Privado ID app from the App Store or Play Store.</p>
            <p><b>Step 2:</b> Set up your account on Privado ID.</p>
            <p><b>Step 3:</b> Scan the code below using your Privado ID application to connect.</p>
          </div>
            <div className="qrbox">
              <img src="../../images/PolygonLogin.png" />
            </div>
        </div>   
        }
  </>;
};

export default Privadoqr;